import { QueryParamProvider as QueryParamProvider_1, encodeQueryParams } from "use-query-params";
import { createObj } from "../.fable/fable-library.3.2.6/Util.js";
import { singleton } from "../.fable/fable-library.3.2.6/List.js";
import * as react from "react";
import { Route } from "react-router-dom";

export function encodeQueryParam(key, paramType, v) {
    return encodeQueryParams(createObj(singleton([key, paramType])), createObj(singleton([key, v])))[key];
}

export function QueryParamProvider(children) {
    return react.createElement(QueryParamProvider_1, {
        ReactRouterRoute: Route,
    }, ...children);
}

